import { Component, OnInit, ViewChild, Output, EventEmitter,  OnChanges, SimpleChanges } from '@angular/core';

import Swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ServicesSunsetService } from 'src/app/components/services-sunset.service';
import { Menu } from 'src/app/components/interfaces/menu.entity';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, OnChanges {
  animated
  mostrar: boolean;
  usuario: string;
  plataforma: string;
  ancho: string;
  selempresa: boolean;
  activo: number;
  tipo: string;
  menu: any;
  banco: any;
  compra: Menu[];
  menuUsuario: Menu;
  venta: any;
  almacen: any;
  produccion: any;
  blnProduccion = false;
  strProduccion: string;
  items: any[]=[];

  @Output() messageEvent: EventEmitter<boolean>;


  constructor(private router: Router, private route: ActivatedRoute, private _servicios: ServicesSunsetService) {

    this.messageEvent = new EventEmitter();

    this.usuario = '';
    
    this.usuario = sessionStorage.getItem('usuario').toString();
  

  }

  cerrarModal() {

    this.mostrar = false;
    this.messageEvent.emit(this.mostrar);

  }

  
  ngOnChanges(changes: SimpleChanges): void {
    
    console.log("hubo algún cambio", changes)

  }

  ngOnInit() {

    
    this.compra = [];

    const _menu = sessionStorage.getItem('menu');

    if (_menu === "") {

      this._servicios.obtenerMenu().subscribe(

        (data: any) => {
  
          this.menu = data;
          
          const myMenu = this.menu.menu;
  
  
           myMenu.forEach(element => {
            
            
              if (element.visible == true) {
        
                  this.menuUsuario = new Menu();
                  this.menuUsuario.visible = element.visible;
                  this.menuUsuario.nombre = element.nombre
                  this.menuUsuario.icono = element.icono;
  
                  element.items.forEach(items => {
                      
                    if (items.visible == true) {
  
                      this.menuUsuario.items.push(items);
  
                    }
  
                  });
  
                  
                  this.compra.push(this.menuUsuario);
  
  
              }  
        
          });
          
        }
  
      );
  

    } else {

          this.menu = JSON.parse(_menu);
          
          const myMenu = this.menu;
  
  
           myMenu.forEach(element => {
            
            
              if (element.visible == true) {
        
                  this.menuUsuario = new Menu();
                  this.menuUsuario.visible = element.visible;
                  this.menuUsuario.nombre = element.nombre
                  this.menuUsuario.icono = element.icono;
  
                  element.items.forEach(items => {
                      
                    if (items.visible == true) {
  
                      this.menuUsuario.items.push(items);
  
                    }
  
                  });
  
                  
                  this.compra.push(this.menuUsuario);
  
  
              }  
        
          });




    }

    



    this.tipo = sessionStorage.getItem('tipo_usuario');
    this.plataforma = window.navigator.platform;
    this.ancho = window.innerWidth.toString();
    this.activo =0;
    this.selempresa = false;
    this.mostrar = false;
    // tslint:disable-next-line: no-unused-expression
    this.blnProduccion = false;
  }


  mostrarMaestros(id:number) {

    this.compra.forEach(element => {

      element.accion = false;

    })

    this.compra[id].expandir = this.compra[id].expandir === '+' ? '-' : '+';
    this.compra[id].accion = !this.compra[id].accion;
    this.items = this.compra[id].items;
  }

 
  cerrarSesion() {


    Swal.fire({
      title: '¿Confima cerrar la sesión?',
      text: '',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, Cerrar!',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {

        this.router.navigate(['/login']);
        sessionStorage.clear();

      }

    });

  }

}
